var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"float-whats",attrs:{"id":_vm.id,"href":_vm.whatsAppLink,"title":"Atendimento via WhatsApp","rel":"noopener noreferrer","target":"_blank"}},[_c('img',{attrs:{"src":require("@img/icons/icon-whatsapp.svg?inline"),"alt":"Atendimento via WhatsApp"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }